
import { Vue, Component, Watch } from "vue-property-decorator";
import RoomPropertiesForm from "@/components/restaurant/table/RoomPropertiesForm.vue";
import RoomDialog from "@/components/restaurant/table/RoomDialog.vue";
import Room from "@/domain/restaurant/Room";
import TableList from "@/components/restaurant/table/TableList.vue";
import DialogBanner from "@/components/app/DialogBanner.vue";
import Restaurant from "@/domain/restaurant/Restaurant";

@Component({
  components: { DialogBanner, TableList, RoomDialog, RoomPropertiesForm }
})
export default class RoomList extends Vue {
  showDialog = true;

  currentTab = 0;

  roomDialog = false;

  selectedRoom = new Room();

  mounted() {
    this.onRestaurantChange();
  }

  selectRoom() {
    if (this.restaurant != null)
      this.selectedRoom = this.restaurant.rooms[this.currentTab];
    else this.selectedRoom = new Room();
  }

  get restaurant(): Restaurant | null {
    return this.$store.getters.getSelectedRestaurant;
  }

  get roomList() {
    if (this.restaurant != null) return this.restaurant.rooms;
    return [];
  }

  @Watch("restaurant")
  onRestaurantChange() {
    if (this.restaurant != null) {
      this.restaurant.rooms.sort(Room.RoomByNameAscendingComparator);
      if (this.restaurant.rooms.length > 0) {
        this.selectRoom();
      }
    } else this.selectRoom();
  }

  get dialog() {
    return this.showDialog;
  }

  set dialog(newValue) {
    this.currentTab = 0;
    // this.showDialog = false;
    this.$router.back();
  }

  get tab() {
    return this.currentTab;
  }

  set tab(newVal) {
    this.currentTab = newVal;
  }

  get isAdmin() {
    return this.$store.getters.isAdmin;
  }

  showRoomDialog() {
    this.roomDialog = true;
    this.selectRoom();
  }

  showNewRoomDialog() {
    this.roomDialog = true;
    this.selectedRoom = new Room();
  }

  addRoom(newRoom: Room) {
    if (this.restaurant != null) {
      this.restaurant.rooms.push(newRoom);
      this.tab = this.restaurant.rooms.length - 1;
      this.restaurant.rooms.sort(Room.RoomByNameAscendingComparator);
    } else console.log("Remove Room: restaurant is null;");
  }

  removeRoom(toRemove: Room) {
    if (this.restaurant != null) {
      const indexToRemove = this.restaurant.rooms.indexOf(toRemove);
      if (indexToRemove > -1) {
        this.restaurant.rooms.splice(indexToRemove, 1);
      }
    } else console.log("Remove Room: restaurant is null;");
  }
}
